import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

import { postAuthDestination, startupLocation } from '@/router/redirect';
import { useAuthStore } from '@/stores/auth';

export async function authNavigationGuard (
  to: RouteLocationNormalized,
): Promise<boolean | RouteLocationRaw> {
  let isAuthenticated = false;

  try {
    isAuthenticated = await useAuthStore().ensureAuthenticatedSession();
  } catch {
    return startupLocation(to.fullPath);
  }

  if (to.meta.public) {
    return isAuthenticated ? postAuthDestination(to.query.redirect) : true;
  }

  return isAuthenticated ? true : startupLocation(to.fullPath);
}
